import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SomaIcon } from '@soma/react';

import Checkbox from 'xpi-black-ui/Base/Checkbox';
import Table, { Thead, Tbody, Tr, Td } from 'xpi-black-ui/Common/Table';

import { convertNumberBR, toMaskNumber, removeMask, convertToCurrency } from 'utils/helpers';
import TableItem from './table-item';

import { TableWrapper, Th } from './styles';

const ClientsTable = ({
  clients,
  hasError,
  errors,
  isRubiYield,
  loteMinimo,
  updateClients,
  favoriteClient,
  onSelectClient,
  onReLoadClient,
  precoReferencia,
  updateClientState,
}) => {
  const [allClientsSelected, setAllClientsSelected] = useState(false);

  const setSelectedFlags = (clients, allClientsSelected) => (
    clients.map(client => (
      client.habilitado
        ? { ...client, isSelected: !allClientsSelected }
        : client
    ))
  );

  const getNumberTarget = (value) => {
    const matchNumbers = value?.toString().match(/[\d]/gi, '');
    return matchNumbers ? Number(matchNumbers.join('')) : 0;
  };

  const updateClientQuantity = (selectedClient, value) => {
    if (!Number.isNaN(value)) {
      const prevQuantity = selectedClient.quantity;
      const valueNatural = getNumberTarget(value);
      let quantity = parseFloat(valueNatural || 0);
      let quantityView = convertNumberBR(valueNatural);
      const notional = precoReferencia * quantity;
      const notionalView = convertToCurrency(notional);
      const hasUpdatedQuantity = quantity !== prevQuantity;

      if (loteMinimo < 1 && loteMinimo > 0) {
        quantityView = toMaskNumber(value);
        quantity = removeMask(quantityView);
      }

      updateClients(selectedClient, client => ({
        ...client,
        notional,
        quantity,
        quantityView,
        notionalView,
        isSelected: Boolean(quantity),
        riskValidated: hasUpdatedQuantity ? false : selectedClient.riskValidated,
        mensagemErrorStatus: hasUpdatedQuantity ? '' : client.riskValidated,
        riskError: hasUpdatedQuantity ? false : client.riskError,
      }));
    }
  };

  const toggleAllClients = () => {
    const updatedClients = setSelectedFlags(clients, allClientsSelected);

    setAllClientsSelected(!allClientsSelected);
    updateClientState(updatedClients);
  };

  const onSelectedClient = (client) => {
    updateClientQuantity(client, client.quantity);
    onSelectClient(client);
  };

  const renderTitlesTable = () => (
    <>
      <Th width="30">
        <Checkbox id="code" checked={allClientsSelected} onChange={() => toggleAllClients()} />
      </Th>
      <Th width="30">&nbsp;</Th>
      <Th>Código</Th>
      <Th width="220">Nome</Th>
      <Th width="120">Quantidade</Th>
      <Th>Status do Cliente</Th>
      {isRubiYield && hasError && (<Th width="50">Motivo do erro</Th>)}
      <Th width="50" />
    </>
  );

  const visibleClients = clients.filter(client => client.isVisible);

  return (
    <>
      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              {renderTitlesTable()}
            </Tr>
          </Thead>
          <Tbody>
            {visibleClients.map(client => (
              <TableItem
                key={client.clienteId}
                client={client}
                hasError={hasError}
                errors={errors}
                isRubiYield={isRubiYield}
                onReLoadClient={onReLoadClient}
                favoriteClient={favoriteClient}
                onSelectedClient={onSelectedClient}
                updateClientQuantity={updateClientQuantity}
              />
            ))}

            {!visibleClients.length && (
              <Tr>
                <Td colSpan="7" style={({ textAlign: 'center', padding: '15px 0' })}>Nenhum cliente encontrado</Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableWrapper>
    </>
  );
};

ClientsTable.propTypes = {
  clients: PropTypes.arrayOf(PropTypes.object).isRequired,
  hasError: PropTypes.bool.isRequired,
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateClients: PropTypes.func.isRequired,
  updateClientState: PropTypes.func.isRequired,
  favoriteClient: PropTypes.func.isRequired,
};

export default ClientsTable;
